import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { Card as RSCard, CardBody } from 'reactstrap';

const TabWithTitle = ({ tabs = [{}], styles = {}, handleTabChange = () => {}, title, subTitle }) => {
    const [tabOn, setTabOn] = useState(tabs[0].tabId);
    useEffect(() => {
        handleTabChange(tabOn);
    }, [tabOn]);

    const handleTabClick = e => {
        e.preventDefault();
        setTabOn(e.target.id);
    };

    return (
        <RSCard>
            <div className="card-header">
                <div className="card-header__title">
                    <div className="title-wrap">
                        <h3 className="title__main">{title}</h3>
                        <p className="title__sub">{subTitle}</p>
                    </div>
                </div>
                <div className="card-header__tab">
                    <ul>
                        {tabs.map((data, index) => (
                            <li
                                key={`${data.tabId}_${index}`}
                                id={data.tabId}
                                className={cx(tabOn === data.tabId && 'on', 'cursor-pointer')}
                                style={{ ...styles.headerItem }}
                                onClick={handleTabClick}
                            >
                                <a href={'#!'} id={data.tabId} onClick={handleTabClick}>
                                    {data.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <CardBody>
                {tabs.map((data, index) => (
                    <div key={`${data.tabId}_${index}`} className={cx(tabOn !== data.tabId && 'd-none')}>
                        {data.content}
                    </div>
                ))}
            </CardBody>
        </RSCard>
    );
};

export default TabWithTitle;
